/* istanbul ignore file */
import { FormSection } from 'framework/ui/layout';
import { useEffect } from 'react';
import { TextInput, useFormContext } from 'framework/form';
import { InputLoader } from 'framework/ui/mui-builder';
import { useAsyncValue } from 'framework/utils';
import { useBudgetService, BudgetInput } from 'domain/shared/budget';

interface SkillBasedQueueFormProps {
  isCreateForm?: boolean;
}

const SkillBasedQueueForm = ({ isCreateForm }: SkillBasedQueueFormProps) => {
  const { data, setFormData } = useFormContext();
  const { getById } = useBudgetService();
  const budgetId = data?.defaultBudgetId;
  const initialBudgetName = data?.defaultBudgetName;
  const budgetData = useAsyncValue(() => (budgetId ? getById(budgetId) : Promise.resolve({})), [budgetId]);
  const budgetName = budgetData?.name;
  useEffect(() => {
    if (budgetId && setFormData && !initialBudgetName) {
      setFormData({
        ...data,
        defaultBudgetName: budgetName,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [budgetId, budgetName]);
  return (
    <FormSection title="Skill based queue information">
      <TextInput label="Skill" source="skillName" errorSource="skillId" disabled={!isCreateForm} />
      {budgetId && !data.defaultBudgetName ? (
        <InputLoader />
      ) : (
        <BudgetInput
          source="defaultBudgetId"
          nameSource="defaultBudgetName"
          label="Default budget"
          searchString="name"
          filter={{ defaultableBudget: true, notArchived: true }}
        />
      )}
    </FormSection>
  );
};

export default SkillBasedQueueForm;
